module.exports = __webpack_public_path__ + "img/date-picker-icon.82514bb9.svg";